import {Row} from "antd";
import React, {useEffect, useState} from "react";
import {PracticeTotalQuotasResponse} from "../../models/Practice/PracticeTotals";
import {PracticeType} from "../../models/Practice/Practice";
import {AttachmentType, PracticeFileRow} from "../../models/Practice/PracticeFIle";
import {PracticeDetail} from "../../models/Practice/PracticeDetail";
import {InsuranceProviderIntegrationCodes} from "../../models/InsuranceProvider";

function formatInsuranceName(integrationCode: string): string {
    return integrationCode.charAt(0).toUpperCase() + integrationCode.slice(1).toLowerCase();
}

function formatQuotaAmount(amount: number): string {
    return `${Number(amount).toFixed(2)} euro`;
}

function getHeaderText(): string {
    return `Di seguito le quote ripartite tra Ente e Cliente`;
}

function getFooterText(): string {
    return `<br/><span><strong>Importante</strong>: in cassa Ciao! imputare quota a carico dell'assicurazione sul tasto corretto.</span> <br><span><strong>Attenzione</strong>: la quota Caparra deve essere sempre uguale o inferiore alla quota a carico dell'assistito.</span>`;
}

export function buildPicQuotasNoteText(integrationCode: string, insuranceAmount: number, patientAmount: number): string {
    return getHeaderText() + `<br/><strong>${formatInsuranceName(integrationCode)}: ${formatQuotaAmount(insuranceAmount)}<br/>Cliente: ${formatQuotaAmount(patientAmount)}</strong>` + getFooterText();
}

export interface TotalsInfoProps {
    data?: PracticeTotalQuotasResponse | undefined,
    integrationCode:string,
    refundType:PracticeType | undefined,
    detail: PracticeDetail,
    loadedFiles: PracticeFileRow[]
}

function estraiMassimoAxa(note:string) {
    if (!note) return null;
    const match = note.match(/[\d.,]+/);
    return match ? parseFloat(
        match[0]
            .replace(/\./g, "")   // rimuove migliaia
            .replace(",", ".")    // converte decimale
    ) : null;
}

export function TotalsInfo(props:TotalsInfoProps)  {
    const [patientAmount,setPatientmount] = useState<number>(0);
    const [insuranceAmount,setInsuranceAmount] = useState<number>(0);
    useEffect(() => {
        loadData();
    }, []);
    const estimateLoaded = props.loadedFiles.find(file => file.type == AttachmentType.ESTIMATE) != undefined;
    const loadData = async () => {
        if(props.refundType === PracticeType.DIRECT && props.data){
            setPatientmount(props.data?.patientAmount)
            setInsuranceAmount(props.data?.insuranceAmount)
        }
    };

    const isAxa = props.detail.picNotes && props.detail.insuranceProvider.integrationCode === InsuranceProviderIntegrationCodes.AXA && props.detail.agreement === PracticeType.DIRECT;
    if (isAxa) {
        const massimaleAxa = estraiMassimoAxa(props.detail.picNotes);
        if (null !== massimaleAxa) {
            if (massimaleAxa < insuranceAmount) {
                console.info("Massimale " + massimaleAxa + " inferiore al insurance del calcolo totali " + insuranceAmount + " - da calcolare quota ente e paziente");
                setPatientmount(insuranceAmount - massimaleAxa);
                setInsuranceAmount(massimaleAxa);
            }
        } else {
            console.info("Impossibile estrarre il massimo dalla nota Axa");
        }
    }
    if (!props.data) {
        return <>
            <Row gutter={16}>
                Totali non disponibili
            </Row>
        </>
    }
    return <>
        <Row gutter={16}>
            {getHeaderText()}
        </Row>
        {(estimateLoaded && isAxa) &&
                <Row gutter={16} style={{marginTop: "16px"}}>
                    <strong>{props.detail.picNotes}</strong>
                </Row>
        }
        <br />
        <Row gutter={16}>
            <strong>{formatInsuranceName(props.integrationCode)}</strong>: {formatQuotaAmount(insuranceAmount)}
        </Row>
        <Row gutter={16}>
            <strong>Cliente</strong>: {formatQuotaAmount(patientAmount)}
        </Row>
        <Row gutter={16}>
            <div dangerouslySetInnerHTML={{ __html: getFooterText() }} />
        </Row>
    </>
}
